<template>
  <div class="version-card">
    <div class="top">
      <div class="title">
        <p>{{ title }}</p>
        <span>上次检测时间：2022-1-14 13:54:42</span>
      </div>
      <div class="right-block">
        <a-button class="btn button-primary" type="primary">
          <template #icon>
            <img src="@/assets/img/devops/refresh.png" />
          </template>
          检测更新
        </a-button>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import { Button } from "ant-design-vue";
export default {
  name: "version-card",
  components: {
    [Button.name]: Button
  },
  props: {
    title: String
  },
  setup() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.version-card {
  // height: calc(100vh - 98px);
  padding: 24px;
  overflow-y: auto;
  text-align: left;
  background-color: #fff;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  .top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
    line-height: 32px;
    .title {
      display: flex;
      color: #1d2129;
      font-weight: 500;
      font-size: 24px;
      line-height: 32px;
      span {
        margin-left: 8px;
        color: #4e5969;
        font-size: 14px;
      }
    }
    .right-block {
      display: flex;
      color: #4e5969;
      .btn {
        height: 32px;
        margin-left: 8px;
        padding: 5px 16px;
        line-height: 22px;
        img {
          width: 16px;
          height: 16px;
          margin-top: 3px;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
